export enum DEPOSIT_STATUSES {
    NOT_PAID = "not_paid",
    PAY_STARTED = "pay_started",
    PAY_ERROR = "pay_error",
    PAID = "paid",
    CANCELLED_WITH_REFUND = "cancelled_with_refund",
    CANCELLED_PARTIALLY = "cancelled_with_partially_refund",
    CANCELLED_WITHOUT_PAYMENT = "cancelled_without_payment",
}

export const depositStatusesSuccess = [
    DEPOSIT_STATUSES.PAID,
    DEPOSIT_STATUSES.CANCELLED_WITH_REFUND,
    DEPOSIT_STATUSES.CANCELLED_PARTIALLY,
    DEPOSIT_STATUSES.CANCELLED_WITHOUT_PAYMENT,
]
